<template>
  <div>
    <div v-if="isSingle">
      <!-- 单图 -->
      <a-upload
        v-if="accept"
        :accept="accept"
        name="avatar"
        listType="picture-card"
        class="avatar-uploader"
        :showUploadList="false"
        :beforeUpload="beforeUpload"
        :customRequest="uploadFile"
        :disabled="disabled"
        :openFileDialogOnClick="!spinning"
      >
        <a-progress
          v-if="spinning"
          type="circle"
          :percent="percentage"
          :width="80"
        />
        <img
          class="image-upload"
          v-else-if="imageUrl"
          :src="imageUrl"
          alt="avatar"
        />
        <img
          class="image-upload"
          v-else-if="!imageUrl && disabled"
          src="/course_cover.png"
          alt="avatar"
        />
        <div v-else>
          <a-icon :type="loading ? 'loading' : 'plus'" />
          <div class="ant-upload-text">{{ btnText ? btnText : '上传' }}</div>
        </div>
      </a-upload>
      <a-upload
        v-else
        name="avatar"
        listType="picture-card"
        class="avatar-uploader"
        :showUploadList="false"
        :beforeUpload="beforeUpload"
        :customRequest="uploadFile"
        :disabled="disabled"
        :openFileDialogOnClick="!spinning"
      >
        <a-progress
          v-if="spinning"
          type="circle"
          :percent="percentage"
          :width="80"
        />
        <img
          class="image-upload"
          v-else-if="imageUrl"
          :src="imageUrl"
          alt="avatar"
        />
        <img
          class="image-upload"
          v-else-if="!imageUrl && disabled"
          src="/course_cover.png"
          alt="avatar"
        />
        <div v-else>
          <a-icon :type="loading ? 'loading' : 'plus'" />
          <div class="ant-upload-text">{{ btnText ? btnText : '上传' }}</div>
        </div>
      </a-upload>
    </div>

    <div v-else>
      <!-- 视频或者多图 -->
      <div>
        <a-upload
          v-if="accept"
          :accept="accept"
          :showUploadList="
            showUploadList === undefined || showUploadList ? true : false
          "
          listType="picture-card"
          :beforeUpload="beforeUpload"
          :fileList="fileList"
          @change="handleChange"
          :customRequest="uploadFile"
          :disabled="disabled"
          :openFileDialogOnClick="!spinning"
        >
          <div v-if="maxlength && fileList.length < maxlength">
            <a-progress
              v-if="spinning"
              type="circle"
              :percent="percentage"
              :width="80"
            />
            <div v-else>
              <a-icon type="plus" />
              <div class="ant-upload-text">
                {{ btnText ? btnText : '上传' }}
              </div>
            </div>
          </div>
          <!-- <a-icon class="icon-file" v-else type="file" /> -->
        </a-upload>
        <a-upload
          v-else
          :showUploadList="
            showUploadList === undefined || showUploadList ? true : false
          "
          listType="picture-card"
          :beforeUpload="beforeUpload"
          :fileList="fileList"
          @change="handleChange"
          :customRequest="uploadFile"
          :disabled="disabled"
          :openFileDialogOnClick="!spinning"
        >
          <div>
            <div v-if="1 || (maxlength && fileList <= maxlength)">
              <a-progress
                v-if="spinning"
                type="circle"
                :percent="percentage"
                :width="80"
              />
              <div v-else>
                <a-icon type="plus" />
                <div class="ant-upload-text">
                  {{ btnText ? btnText : '上传' }}
                </div>
              </div>
            </div>
            <a-icon class="icon-file" v-else type="file" />
          </div>
        </a-upload>
      </div>
      <a-modal
        :maskClosable="false"
        :visible="previewVisible"
        :footer="null"
        @cancel="handleCancel"
      >
        <img alt="example" style="width: 100%" :src="previewImage" />
      </a-modal>
    </div>
    <div class="choose-hint" v-if="!isCheck">请选择并上传文件</div>
  </div>
</template>
<script>
import ossApi from '../../api/oss'

import OSS from 'ali-oss'

import { v1 as uuidv1 } from 'uuid'

export default {
  name: 'CUpload',
  data() {
    return {
      previewVisible: false,
      previewImage: '',
      loading: false,
      fileList: [],
      imageUrl: '',
      isCheck: true,
      spinning: false,
      percentage: 0, // 上传进度
    }
  },
  props: [
    'ossType',
    'isSingle',
    'sourceFileList',
    'disabled',
    'maxlength',
    'accept',
    'btnText',
    'showUploadList',
    'displayUpload',
    'maxFileSize',
    'imageMaxWidth',
    'imageMaxHeight',
    'imageMatchWidth',
    'imageMatchHeight',
    'imageWidthHeightRatio',
    'imageMinWidth',
    'imageMinHeight',
    'messageTitle',
  ],
  watch: {
    sourceFileList: {
      handler: function () {
        this.init()
      },
      deep: true,
    },
    spinning: {
      handler: function () {
        if (!this.spinning) this.percentage = 0
      },
      deep: true,
    },
  },

  methods: {
    //校验
    check() {
      if (
        (this.isSingle && !this.imageUrl) ||
        (!this.isSingle && this.fileList.length == 0)
      ) {
        this.isCheck = false
      } else {
        this.isCheck = true
      }
      return new Promise((resolve) => {
        resolve(this.isCheck)
      })
    },

    getUuid() {
      return uuidv1().replace(/-/g, '')
    },

    handleCancel() {
      // console.log('haha')
      this.previewVisible = false
    },

    handlePreview(file) {
      // console.log(file)
      this.previewImage = file.url || file.thumbUrl
      this.previewVisible = true
    },

    handleChange(info) {
      // console.log('info', info)
      if (info.file && info.file.status === 'removed') {
        this.fileList = info.fileList
        // ----不改变父组件的引用数组，改变数组中的数据----
        // https://v2.cn.vuejs.org/v2/guide/components-props.html#Prop-%E7%B1%BB%E5%9E%8B
        var originalList = [];
        while ((this.sourceFileList instanceof Array) && this.sourceFileList.length > 0) {
          var url = this.sourceFileList.pop();
          if (url === info.file.url) {
            continue;
          }
          originalList.push(url);
        }
        while (originalList.length > 0) {
          this.sourceFileList.push(originalList.pop());
        }
        // ----不改变父组件的引用数组，改变数组中的数据----
        // console.log(this.fileList)
        this.$emit('uploadSuccess', this.fileList)
      }
    },
    imageResolutionHandle(file, checkFunction) {
      var ctrl = this
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (theFile) => {
          const image = new Image()
          image.src = theFile.target.result
          image.onload = (res) => {
            const imgNode = res.target //res.path[0]
            const { width, height } = imgNode
            var description = ''
            if (
              description == '' &&
              !isNaN(ctrl.imageMinWidth) &&
              !isNaN(ctrl.imageMinHeight) &&
              (width < parseInt(ctrl.imageMinWidth) ||
                height < parseInt(ctrl.imageMinHeight))
            ) {
              description =
                '上传图片必须大于宽' +
                ctrl.imageMinWidth +
                '像素，高' +
                ctrl.imageMinHeight +
                '像素，当前选择文件尺寸：' +
                width +
                '*' +
                height +
                '不符合限制大小，请重新选择上传文件。'
            }
            if (
              description == '' &&
              !isNaN(ctrl.imageMaxWidth) &&
              !isNaN(ctrl.imageMaxHeight) &&
              (width > parseInt(ctrl.imageMaxWidth) ||
                height > parseInt(ctrl.imageMaxHeight))
            ) {
              description =
                '上传图片必须在宽' +
                ctrl.imageMaxWidth +
                '像素，高' +
                ctrl.imageMaxHeight +
                '像素范围内，当前选择文件尺寸：' +
                width +
                '*' +
                height +
                '超出限制大小，请重新选择上传文件。'
            }
            if (
              description == '' &&
              !isNaN(ctrl.imageMatchWidth) &&
              !isNaN(ctrl.imageMatchHeight) &&
              (width != parseInt(ctrl.imageMatchWidth) ||
                height != parseInt(ctrl.imageMatchHeight))
            ) {
              description =
                '上传图片必须符合宽' +
                ctrl.imageMatchWidth +
                '像素，高' +
                ctrl.imageMatchHeight +
                '像素，当前选择文件尺寸：' +
                width +
                '*' +
                height +
                '不符合限制大小，请重新选择上传文件。'
            }
            if (
              description == '' &&
              !isNaN(ctrl.imageWidthHeightRatio) &&
              Math.abs(
                width / height - parseFloat(ctrl.imageWidthHeightRatio)
              ) > 0.01
            ) {
              description =
                '上传图片必须符合宽/高比：' +
                ctrl.imageWidthHeightRatio +
                '，当前选择文件尺寸：' +
                width +
                '*' +
                height +
                '不符合宽高比要求，请重新选择上传文件。'
            }
            if (description.length > 0) {
              ctrl.$notification.open({
                message:
                  ctrl.messageTitle && ctrl.messageTitle.length > 0
                    ? ctrl.messageTitle
                    : '图片尺寸错误',
                description: description,
                duration: 0,
              })
              resolve(false)
              return
            }
            resolve(true)
          }
        }
      })
    },
    checkFileSize(file) {
      var fileSize = -1
      if (
        this.$props.accept === 'image/*' &&
        file.type.includes('image') &&
        isNaN(this.maxFileSize)
      ) {
        // 图片默认最大10MB
        fileSize = 1024 * 1024 * 10
      } else if (
        this.$props.accept === 'video/*' &&
        file.type.includes('video') &&
        isNaN(this.maxFileSize)
      ) {
        // 视频默认最大200MB
        fileSize = 1024 * 1024 * 200
      } else if (!isNaN(this.maxFileSize)) {
        // 非默认值的时候，每个控件设定独立的文件大小限制
        fileSize = parseInt(this.maxFileSize)
      }
      var convert = fileSize
      if (convert > 0) {
        //转换为人可以理解的大小
        var fileSizeShow = ''
        if (convert < 1024) {
          fileSizeShow = convert + '字节'
        } else {
          convert = convert / 1024
          if (convert < 1024) {
            fileSizeShow = convert + 'KB'
          } else {
            convert = convert / 1024
            if (convert < 1024) {
              fileSizeShow = convert + 'MB'
            } else {
              convert = convert / 1024
              fileSizeShow = convert + 'GB'
            }
          }
        }
        if (file != null && file.size > fileSize) {
          this.$message.error(
            (this.messageTitle && this.messageTitle.length > 0
              ? this.messageTitle
              : '') +
              '上传文件大小不能超过：' +
              fileSizeShow +
              '，请重新选择在此范围内的文件'
          )
          this.spinning = false
          return false
        }
      }
      return true
    },
    beforeUpload(file) {
      var ctrl = this
      return new Promise((resolve, reject) => {
        if (!ctrl.checkFileSize(file)) {
          return reject(file)
        }
        if (ctrl.$props.accept === 'image/*' && file.type.includes('image')) {
          ctrl
            .imageResolutionHandle(file)
            .then((state) => {
              if (state) {
                return resolve(file)
              } else {
                ctrl.spinning = false
                return reject(file)
              }
            })
            .catch((r) => {
              ctrl.spinning = false
              return reject(file)
            })
        } else if (
          ctrl.$props.accept &&
          ctrl.$props.accept.length > 0 &&
          !file.type.includes(ctrl.$props.accept.split('/')[0])
        ) {
          this.$message.error(
            (this.messageTitle && this.messageTitle.length > 0
              ? this.messageTitle
              : '') + '上传文件类型不正确，请重新选择在此范围内的文件'
          )
          this.spinning = false
          return reject(file)
        } else {
          return resolve(file)
        }
      })
    },

    getFileUrl(fileType) {
      return `${this.ossType}/${this.getUuid()}.${fileType}`
    },

    async uploadFile(e) {
      this.spinning = true
      let self = this
      let file = e.file
      this.getStsToken().then((res) => {
        let fileName = file && file.name ? file.name.split('.') : ['jpg']
        let storeAs = this.getFileUrl(fileName[fileName.length - 1])
        let client = new OSS({
          accessKeyId: res.accessKeyId,
          accessKeySecret: res.accessKeySecret,
          stsToken: res.securityToken,
          bucket: 'after-class',
          region: 'oss-cn-hangzhou',
        })
        //storeAs表示上传的object name , file表示上传的文件
        client
          .multipartUpload(storeAs, file, {
            parallel: 4,
            partSize: 1024 * 1024,
            progress: self.pace,
          })
          .then(function (result) {
            let url = window.globalConfig.fileUrl + result.name
            self.successUpload(file, url)
          })
          .catch(function (err) {
            console.error('文件上传失败', err)
            self.$message.error(
              '文件上传失败:"' + err.message + '" 请重新尝试上传。'
            )
          })
          .finally(() => {
            this.spinning = false
          })
      })
    },
    // 获取上传进度
    pace(p, cpt, res) {
      this.percentage = Math.round(p * 100)
    },
    //多文件上传和单文件上传处理
    successUpload(file, url) {
      if (!this.isSingle) {
        this.fileList.push({
          uid: this.getUuid(),
          name: file.name,
          url: url,
        })
        // ----不改变父组件的引用数组，改变数组中的数据----
        this.sourceFileList.push(url);
        // ----不改变父组件的引用数组，改变数组中的数据----
        this.$emit('uploadSuccess', this.fileList)
      } else {
        this.imageUrl = url
        this.loading = false
        // ----不改变父组件的引用数组，改变数组中的数据----
        if (this.sourceFileList.length == 0) {
          this.sourceFileList.push(url);
        } else {
          this.sourceFileList[0] = url;
        }
        // ----不改变父组件的引用数组，改变数组中的数据----
        this.$emit('uploadSuccess', url)
      }
    },

    //获取OSS token
    getStsToken() {
      let tempStsToken = this.$ls.get('stsToken')
      let promise = new Promise((resolve, reject) => {
        if (tempStsToken) {
          let tempDate = new Date(tempStsToken.expiration)
          let tempNowDate = new Date()
          if (tempNowDate.getTime() > tempDate.getTime()) {
            ossApi.getOssStsToken().then((res) => {
              //把stsToken放入对应的缓存里
              this.$ls.set('stsToken', res.stsToken)
              resolve(res.stsToken)
            })
          } else {
            resolve(tempStsToken)
          }
        } else {
          ossApi.getOssStsToken().then((res) => {
            //把stsToken放入对应的缓存里
            this.$ls.set('stsToken', res.stsToken)
            resolve(res.stsToken)
          })
        }
      })
      return promise
    },

    //初始化
    init() {
      if (!this.sourceFileList || this.sourceFileList.length == 0) {
        this.imageUrl = ''
        this.fileList = []
        return
      }
      //单个文件
      if (this.isSingle) {
        this.imageUrl = this.sourceFileList[0]
      } else {
        this.fileList = []
        if (!Array.isArray(this.sourceFileList)) {
          let url = this.sourceFileList
          this.fileList.push({
            uid: this.getUuid(),
            name: this.getUuid(),
            url: url,
          })
        } else {
          for (let i in this.sourceFileList) {
            let url = this.sourceFileList[i]
            this.fileList.push({
              uid: this.getUuid(),
              name: i,
              url: url,
            })
          }
        }

        // this.fileList = []
        // for (let i in this.sourceFileList) {
        //   let url = this.sourceFileList[i]
        //   this.fileList.push({
        //     uid: this.getUuid(),
        //     name: i,
        //     url: url,
        //   })
        // }
      }
    },
  },
  created() {
    this.init()
  },
}
</script>
<style lang="scss" scoped>
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
.image-upload {
  width: 100px;
  height: 100px;
}
.choose-hint {
  color: #f5222d;
  position: relative;
  top: -8px;
}
.icon-file {
  color: #40a9ff !important;
}
</style>